module.exports = __webpack_public_path__ + "media/images/emblems/Subingen-blason-038161dfe4b2dd074bf536e1624e8635.png";